export function getLiquidCustomBoolean(key) {
    var _a;
    if (typeof window === "undefined")
        return false;
    return ((_a = window.liquidCustom) === null || _a === void 0 ? void 0 : _a[key]) === true;
}
export function useAlternativeLayout() {
    return getLiquidCustomBoolean("useAlternativeLayout");
}
export function getBorderTop() {
    return getLiquidCustomBoolean("borderTop");
}
